import { PageContainer } from 'src/shared/components/PageContainer'
import { LoginSignupBackdrop } from './components/LoginSignupBackdrop'
import { LoginSignupPanel } from './LoginSignupPanel'

export const LoginSignup = () => {
  return (
    <div className="relative grid min-h-dvh place-items-center overflow-hidden bg-theme_light px-6 py-6">
      <LoginSignupBackdrop />

      <PageContainer width="xl" className="relative z-10 h-auto py-0">
        <LoginSignupPanel loginModeSource="url" className="w-full" />
      </PageContainer>
    </div>
  )
}
